<template>
    <div>
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getListData">
            <div v-for="(item,index) in list" :key="index"
                 style="display: flex; align-items: center; justify-content: space-between; padding: 15px; margin-bottom: 1px; background-color: white;">
                <div style="display: flex; align-items: center;">
                    <van-image round width="50px" height="50px" :src="item.imageUrl ? item.imageUrl : require('@/assets/defaultProfile.jpg')"/>
                    <div style="color: #333333; font-size: 14px; margin-left: 10px;">{{item.userName}}</div>
                </div>
                <div style="color: #999999; font-size: 12px; display: flex; flex-direction: column; align-items: flex-end; justify-content: center;">
                    <div style="margin-bottom: 10px;">加入时间</div>
                    <div>{{item.shareDate|dateFormat('YYYY-MM-DD')}}</div>
                </div>
            </div>
        </van-list>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {List, Cell, Image} from 'vant';

    Vue.use(List).use(Cell).use(Image);

    export default {
        name: "Invited",
        created() {

        },
        data() {
            return {
                list: [],
                loading: false,
                finished: false,
                page: 0,
                pageSize: 10
            }
        },
        methods: {
            getListData() {
                if (this.finished) {
                    return
                }
                this.page++
                this.$axios.get("/integral/list",{params: {shareType: '1', page: this.page, pageSize: this.pageSize}}).then(res => {
                    this.loading = false
                    const data = res.data.rows;
                    this.list = this.list.concat(data);
                    if (data.length < this.pageSize) {
                        this.finished = true;
                    }
                }).catch(err => {
                    this.loading = false
                })
            }
        }
    }
</script>

<style scoped>

</style>
